module.exports = __webpack_public_path__ + "media/landing_page/collapse-01a26ed2.svg";